<template>
  <product-reviews-summary v-bind="forwarded" />
</template>

<script lang="ts" setup>
import type { Props } from '#commerce/components/product/reviews/Summary.vue'
import ProductReviewsSummary from '#commerce/components/product/reviews/Summary.vue'

const props = defineProps<Props>()
const forwarded = useForwardProps(props)

const { $feature } = useNuxtApp()
const { brandClasses, reviews } = useAppConfig().pages.pdp

if ($feature.tempShowATCAboveFold) {
  brandClasses.reviewsCount = 'self-center lg:flex'
  brandClasses.reviewsLink = 'items-center gap-2 i-flex lg:grow'
  brandClasses.reviewsRatingSummary = 'b-t b-grey-70 py-4 lg:py-3'
  brandClasses.reviewsRecommendations = 'mb-0'
  reviews.recommendationRatioAboveReviews = false
}
</script>
